<template>
  <div>
    <v-btn class="primary" tile width="245" height="60" text @click="dialog = true">add category</v-btn>
    <v-dialog max-width="600px" v-model="dialog">
      <v-form v-model="valid" ref="form">
        <v-card>
          <v-card-title>
            <span class="headline">Add new category</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-text-field
                    outlined
                    tile
                    label="Name"
                    v-model="category"
                    :autofocus="true"
                    :rules="nameRules"
                    @keydown.enter.prevent="onClickCategory"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters justify="end">
              <v-col cols="auto">
                <v-btn
                  outlined
                  tile
                  class="ma-2"
                  color="primary"
                  @click.prevent="dialog = false"
                >Cancel</v-btn>
                <v-btn
                  text
                  tile
                  class="ma-2 primary"
                  @click.prevent="onClickCategory"
                  :loading="loading"
                  :disabled="loading"
                >Add new Category</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "CategoryForm",
  data() {
    return {
      dialog: false,
      category: "",
      loading: false,
      valid: false,
      nameRules: [v => !!v || "Name is required"]
    };
  },
  methods: {
    ...mapActions(["addTopCategory", 'setSnackbar']),
    async onClickCategory() {
      this.$refs.form.validate();
      if (!this.valid) return;
      this.loading = true;
      try {
        const newCategory = await this.addTopCategory(this.category);

        this.$emit("categoryCreate", newCategory.data._id);
        this.dialog = false;
        this.loading = false;
        this.category = "";
        this.setSnackbar({
          text: `New Category created.`
        });
      } catch (error) {
        // console.log(error);
      }
    }
  }
});
</script>
